(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (() => {
  const tagName = 'bladeorbit-sale-countdown';
  if (customElements.get(tagName)) return;

  const deadlines = new Map();
  const retentionMs = 365 * 24 * 60 * 60 * 1000;
  const parseDeadline = (value) => {
    const deadline = Number(value);
    return Number.isSafeInteger(deadline) && deadline > 0 ? deadline : null;
  };
  const tryRead = (read) => {
    try { return read(); } catch { return null; }
  };
  const readCookie = (key) => {
    const prefix = `${key}=`;
    return document.cookie.split(';').map((item) => item.trim())
      .find((item) => item.startsWith(prefix))?.slice(prefix.length) ?? null;
  };

  function persistentDeadline(key, durationMs, incoming = null) {
    const local = parseDeadline(tryRead(() => localStorage.getItem(key)));
    const cookie = parseDeadline(tryRead(() => readCookie(key)));
    const candidates = [local, cookie, deadlines.get(key), parseDeadline(incoming)]
      .filter((value) => value !== null && value !== undefined);
    const deadline = candidates.length ? Math.min(...candidates) : Date.now() + durationMs;
    if (!Number.isSafeInteger(deadline)) return null;

    // Preserve expired records too: revisiting must never start this campaign again.
    let persisted = local === deadline || cookie === deadline;
    if (local !== deadline) {
      try {
        localStorage.setItem(key, String(deadline));
        persisted = parseDeadline(localStorage.getItem(key)) === deadline || persisted;
      } catch { /* Cookie storage can still preserve this deadline. */ }
    }
    if (cookie !== deadline) {
      try {
        const expires = new Date(deadline + retentionMs).toUTCString();
        document.cookie = `${key}=${deadline}; Expires=${expires}; Path=/; Secure; SameSite=Lax`;
        persisted = parseDeadline(readCookie(key)) === deadline || persisted;
      } catch { /* Local storage can still preserve this deadline. */ }
    }
    if (!persisted) return null;
    deadlines.set(key, deadline);
    return deadline;
  }

  class SaleCountdown extends HTMLElement {
    static observedAttributes = ['data-campaign', 'data-duration-seconds', 'data-preview', 'data-expired-label'];
    #deadline = null;
    #durationMs = 0;
    #key = '';
    #preview = false;
    #interval;

    connectedCallback() {
      this.disconnectedCallback();
      this.hidden = true;
      delete this.dataset.expiresAt;
      const campaign = this.dataset.campaign?.trim();
      const durationSeconds = Number(this.dataset.durationSeconds);
      if (!campaign || !Number.isSafeInteger(durationSeconds) || durationSeconds <= 0) return;
      const key = `bladeorbit_sale_${encodeURIComponent(campaign)}`;
      const durationMs = durationSeconds * 1000;
      if (!Number.isSafeInteger(durationMs)) return;
      const preview = this.dataset.preview === 'true';
      const reusePreview = preview && this.#preview && this.#key === key && this.#durationMs === durationMs;
      this.#key = key;
      this.#durationMs = durationMs;
      this.#preview = preview;
      this.#deadline = preview
        ? (reusePreview ? this.#deadline : Date.now() + durationMs)
        : persistentDeadline(key, durationMs);
      this.setAttribute('role', 'timer');
      this.setAttribute('aria-live', 'off');
      if (this.#deadline === null) return;
      this.hidden = false;
      document.addEventListener('visibilitychange', this.#refresh);
      window.addEventListener('pageshow', this.#refresh);
      if (!preview) window.addEventListener('storage', this.#storageChanged);
      this.#refresh();
    }

    disconnectedCallback() {
      clearInterval(this.#interval);
      this.#interval = undefined;
      document.removeEventListener('visibilitychange', this.#refresh);
      window.removeEventListener('pageshow', this.#refresh);
      window.removeEventListener('storage', this.#storageChanged);
    }

    attributeChangedCallback() {
      if (this.isConnected) this.connectedCallback();
    }

    #storageChanged = (event) => {
      if (event.key !== this.#key && event.key !== null) return;
      this.#deadline = persistentDeadline(this.#key, this.#durationMs, event.newValue);
      this.#refresh();
    };

    #refresh = () => {
      clearInterval(this.#interval);
      this.#interval = undefined;
      if (!this.#preview) this.#deadline = persistentDeadline(this.#key, this.#durationMs);
      this.hidden = this.#deadline === null;
      if (this.hidden) {
        delete this.dataset.expiresAt;
        return;
      }
      this.dataset.expiresAt = String(this.#deadline);
      this.#render();
      if (!document.hidden && this.#deadline > Date.now()) {
        this.#interval = setInterval(() => this.#render(), 1000);
      }
    };

    #render() {
      const remaining = Math.max(0, Math.ceil((this.#deadline - Date.now()) / 1000));
      const parts = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      ['hours', 'minutes', 'seconds'].forEach((name, index) => {
        const part = this.querySelector(`[data-countdown-${name}]`);
        if (part) part.textContent = String(parts[index]).padStart(2, '0');
      });
      const expired = remaining === 0;
      this.dataset.expired = String(expired);
      const label = this.dataset.expiredLabel || "Time's up";
      const status = this.querySelector('[data-countdown-status]');
      if (status) {
        status.hidden = !expired;
        status.textContent = expired ? label : '';
      }
      this.setAttribute('aria-label', expired
        ? `Sale countdown: ${label}`
        : `Sale countdown: ${parts[0]} hours, ${parts[1]} minutes, ${parts[2]} seconds remaining`);
      if (expired) {
        clearInterval(this.#interval);
        this.#interval = undefined;
      }
    }
  }

  customElements.define(tagName, SaleCountdown);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-email-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bo-email-offer')) {
    customElements.define('bo-email-offer', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const copyButton = this.querySelector('.bo-email-offer__action');
        if (!copyButton) return;
        const buttonLabel = copyButton.getAttribute('aria-label');
        copyButton.addEventListener('click', async () => {
          const status = this.querySelector('[role="status"]');
          clearTimeout(this.resetTimer);
          try {
            await navigator.clipboard.writeText(this.dataset.code);
            status.hidden = true;
            copyButton.textContent = 'Copied!';
            copyButton.setAttribute('aria-label', `Copied ${this.dataset.code}`);
            this.resetTimer = setTimeout(() => {
              copyButton.textContent = 'Get Code';
              copyButton.setAttribute('aria-label', buttonLabel);
            }, 2000);
          } catch {
            const codeRange = document.createRange();
            codeRange.selectNodeContents(this.querySelector('code'));
            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(codeRange);
            copyButton.textContent = 'Get Code';
            copyButton.setAttribute('aria-label', buttonLabel);
            status.textContent = `Copy ${this.dataset.code} manually from the selected text.`;
            status.hidden = false;
          }
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        clearTimeout(this.resetTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
